import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  fileUpload,
  getSignature,
  getSignatureById,
  updateSignature,
  updateUser,
} from "../../../store/actions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CKEditor from "react-ckeditor-component";
import Loading from "../../../Common/extra/loading";
import { checkValidations } from "../../../Services/Helper";
import FileUploader from "../Customers/FilePreview";

const EmailSignatureIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const signData = useSelector((s) => s?.Signatures?.signatures?.data);
  const [data, setData] = useState({
    id: "",
    // signature_title: "",
    // signature_footer_title: "",
    image_url: [],
    signatures_data: "",
    status: "active",
  });

  const [errors, setError] = useState({
    disabled: true,
    signatures_data: "",
    image_url: "",
    // signature_title: "",
    // signature_footer_title: "",
    // signature_email: "",
  });

  useEffect(() => {
    dispatch(getSignatureById(1));
  }, []);

  useEffect(() => {
    let formData = new FormData();
    for (let index = 0; index < uploadedFiles.length; index++) {
      formData.append("project_image[]", uploadedFiles[index]);
    }
    const callBack = (url) => {
      if (url) {
        setData((pre) => ({
          ...pre,
          image_url: [...pre.image_url, ...url?.files], // Spread the elements of `files` array
        }));
      }
    };
    if (uploadedFiles.length > 0) {
      dispatch(fileUpload(formData, null, callBack));
    }
  }, [uploadedFiles]);

  useEffect(() => {
    if (signData) {
      setData((pre) => ({
        ...pre,
        // signature_email: signData?.signature_email,
        image_url: JSON.parse(signData?.image_url),
        signature_title: signData?.signature_title,
        signatures_data: signData?.signatures_data,
        status: signData?.status,
        id: 1,
      }));
    }
  }, [signData]);

  useEffect(() => {
    let validate = checkValidations(data);
    if (!validate.error) {
      setError((pre) => ({ ...pre, disabled: false }));
    } else {
      setError((pre) => ({ ...pre, disabled: true }));
    }
  }, [data]);

  const onChange = (evt) => {
    const newContent = evt.editor.getData();
    setData((prevState) => ({
      ...prevState,
      signatures_data: newContent,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const postCallBack = (res) => {
      setLoading(false);
      if (res.data) {
        // dispatch(getSignatureById(1));
        toast.success("Success!");
      }
    };

    dispatch(
      updateSignature(
        { ...data, image_url: JSON.stringify(data.image_url) },
        postCallBack
      )
    );
  };

  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/customers">
                    Email Signature
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  <Row>
                    <Col
                      lg="12"
                      className="my-2 custom-attach email-temp-attach"
                    >
                      <label for="" className="form-label2 m-0">
                        Attach File:
                      </label>
                      <FileUploader
                        setUploadedFiles={setUploadedFiles}
                        uploadedFiles={uploadedFiles}
                        ImageUrl={data.image_url}
                        setData={setData}
                      />
                    </Col>
                    <Col lg="12" className="my-2">
                      <CKEditor
                        activeClass="p10"
                        content={data.signatures_data}
                        events={{
                          change: onChange,
                        }}
                      />
                    </Col>
                    {/* <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Signature Footer Title
                      </label>
                      <input
                        type="text"
                        name="signature_footer_title"
                        value={data?.signature_footer_title}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.signature_footer_title}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Email
                      </label>
                      <input
                        type="text"
                        name="signature_email"
                        value={data?.signature_email}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.signature_email}
                      </span>
                    </Col> */}

                    <Col lg="12" className="my-2">
                      <div className="pt-4 btn-wrp d-flex algign-items-center">
                        <Button
                          disabled={
                            data.image_url.length < 1 ||
                            data.signatures_data == ""
                              ? true
                              : false
                          }
                          onClick={handleSubmit}
                          className={`d-inline-flex align-items-center justify-content-center me-2`}
                        >
                          Submit
                        </Button>
                        <Link
                          to={`/customers`}
                          className="d-flex btn-2 border align-items-center justify-content-center me-2"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                            >
                              <path
                                d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Back
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default EmailSignatureIndex;
